import React,{ useState } from 'react';
import { useStyles } from '../styles';
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import {Box} from "@material-ui/core";
import CurrencySymbol from './CurrencySymbol';
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { getPriceWithIncrease } from '../util';

export default function Varieties(props) {
  const styles = useStyles();
  let userData = props.userData;
  if(!props.orderItem.varietyPrices||
    props.orderItem.varietyPrices == "\"\"" || 
    props.orderItem.varietyPrices == "{}")
    {
      return null;
    }
  
  let varieties = JSON.parse(props.varieties);
  let varNames= Object.keys(varieties);
  let selectedList =Object.keys(props.orderItem.sub_pro.variety);
  let selVarArr = selectedList.length?selectedList:
  props.handleVarieties(varNames[0],varieties[varNames[0]])
  
  return (
    <div style={{ textAlign: "center", marginTop:"15px",width:'100%' }} data-index={1}>
    <h5 ><i style={{color:'#fff'}}>{props.t({ id: "choose_your" })}</i>{" "} {props.t({ id: "select_size" })}</h5>
    
    <ToggleButtonGroup
        value={selVarArr}
        exclusive
        aria-label="text alignment"
        style={{display:"inline-block",textAlign:"center",margin:"5px" }}
      >

        {varNames.map((varName, index) => {
          const isSelected = selVarArr && selVarArr.indexOf(varName) > -1;
          return (
          <ToggleButton
            key={index}
            style={{
              position: "relative",
              border: isSelected ? "2px solid #23B909" : "1px solid #ccc",
              display: "inline-block",
              padding: "10px",
              margin: "5px",
              borderRadius: "8px",
              fontSize: "1.0em",
              backgroundColor: isSelected ? "#fff" : "#f9f9f9",
              color: "#000",
              overflow: "visible",
              textTransform: "none"
            }}
            value={varName}
            onClick={()=>props.handleVarieties(varName,varieties[varName])}
            aria-label="left aligned"
          >
            {isSelected && (
              <CheckCircleIcon 
                style={{
                  position: "absolute",
                  top: "-8px",
                  left: "-8px",
                  color: "#23B909",
                  backgroundColor: "#fff",
                  borderRadius: "50%",
                  fontSize: "24px",
                  zIndex: 10
                }}
              />
            )}
            <div style={{ display: "block", width: "100%" }}>{varName}</div>
            <div
              style={{ color: "#000", fontWeight: "bold", fontSize: "1.0em" }}
            >
              <CurrencySymbol />{getPriceWithIncrease(varieties[varName], props.orderItem.onlineIncreaseBy || 0)}
            </div>
          </ToggleButton>
          );
        })}
     </ToggleButtonGroup></div>
  );
}
